export const EventCurrencyChanged = "coingecko-currency-changed";
export const EventPriceLoaded = "coingecko-price-loaded"; // new price elements loaded/injected into DOM
export const EventPriceChanged = "coingecko-price-changed";

export const EventPriceChartReload = "coingecko-price-chart-reload";
export const EventPricePercentageChanged = "coingecko-price-percentage-changed";

export const EventToast = "coingecko-toast";
export const EventDarkMode = "coingecko-darkmode";

export const EventResetTooltip = "coingecko-reset-tooltip";

export const EventScroll = "coingecko-scroll";

export const EventCheckUserLogin = "coingecko-check-user-login";
